export function getRandomNumber(a: number, b: number) {
    return Math.random() - 0.5;
}
